module.exports = __webpack_public_path__ + "public/img/app_code.ae91becc.png";